import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import spinner from 'assets/img/spinner.gif';

import './Loader.scss';

export const Loader = () => {
    const { t, i18n } = useTranslation();

    return (
        <div className="loader" data-cy="loader_loadingImage">
            <img src={spinner} alt={t('loader.loading')} className="loaderImg" />
        </div>
    );
};